import { useEffect } from 'react';
import {
    AmbassadorBanner,
    ReferralBanner,
    ReferralHowTo,
    ReferralsAnalytics,
    ReferralsHeader,
    ReferralsTable,
    ShareReferralLink,
    useReferrals,
} from '@/features/referrals';
import { useGlobalStore } from '@/stores';

export default function ReferralsPage() {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);

    // Fetch referrals to determine which sections to show
    const { referrals, isLoading } = useReferrals({ page: 1, pageSize: 1 });
    const hasReferrals = referrals.length > 0;

    useEffect(() => {
        setBreadcrumbs([{ title: 'Referrals', to: '/referrals', active: true, id: 'referrals' }]);
    }, [setBreadcrumbs]);

    // Show loading state while checking for referrals
    if (isLoading) {
        return (
            <div className='flex h-96 w-full items-center justify-center'>
                <p className='text-label-sm-regular text-gray'>Loading...</p>
            </div>
        );
    }

    return (
        <div className='flex w-full flex-col gap-8'>
            {/* Show intro sections only when there are NO referrals */}
            {!hasReferrals && (
                <>
                    <ReferralsHeader />
                    <ReferralBanner />
                    <ReferralHowTo />
                </>
            )}

            {/* Show analytics and data sections only when there ARE referrals */}
            {hasReferrals && (
                <>
                    <ReferralsAnalytics />
                    <ShareReferralLink />
                    <ReferralsTable />
                    <AmbassadorBanner />
                </>
            )}
        </div>
    );
}
